
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class NeuralNetworkEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const spacing = (250 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.fillStyle = pc.color;

        const points: {x: number, y: number}[] = [];
        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const offX = Math.sin(curTime + x * 0.1) * spacing * 0.4;
                const offY = Math.cos(curTime + y * 0.1) * spacing * 0.4;
                points.push({ x: x + offX, y: y + offY });
            }
        }

        const draw = () => {
            for (let i = 0; i < points.length; i++) {
                const p1 = points[i];
                const pulse = (Math.sin(curTime * 2 + i) + 1) * 0.5;
                ctx.globalAlpha = 0.3 + pulse * 0.7;
                ctx.beginPath();
                ctx.arc(p1.x, p1.y, (2 + pulse * 4) * scale, 0, Math.PI * 2);
                ctx.fill();

                for (let j = i + 1; j < Math.min(i + 5, points.length); j++) {
                    const p2 = points[j];
                    const dist = Math.hypot(p1.x - p2.x, p1.y - p2.y);
                    if (dist < spacing * 1.8) {
                        ctx.lineWidth = (0.5 + pulse * 1) * scale;
                        ctx.globalAlpha = (1 - dist / (spacing * 1.8)) * 0.3;
                        ctx.beginPath();
                        ctx.moveTo(p1.x, p1.y);
                        // Curved lines
                        ctx.quadraticCurveTo((p1.x + p2.x) / 2 + Math.sin(curTime) * 20, (p1.y + p2.y) / 2 + Math.cos(curTime) * 20, p2.x, p2.y);
                        ctx.stroke();
                    }
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
